import CalliaAxio from './callia-axios';

export default CalliaAxio;